<template>
    <div><!--ini -->
    <h1>Seleccion de Indicadores</h1>


   
  <div> <v-breadcrumbs :items="items" large></v-breadcrumbs> </div>
    
  <v-card class="blue-grey lighten-5 ma-3 pa-3">
<v-row>
  <v-col cols="12">
    
      <template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    hide-default-footer
    item-key="name"
    show-select
    class="elevation-1"
  ></v-data-table>
</template>

  </v-col>
   <v-col cols="12">

     <template>
  <v-data-table
    :headers="headers2"
    :items="desserts2"
    hide-default-footer
    item-key="name"
    show-select
    class="elevation-1"
  ></v-data-table>
</template>

  </v-col>
</v-row>
</v-card>

    </div>
</template>

<script>
    export default {
  name: 'seleccionIndicadores',

  data() {
    return {

        nombre: '',
    
        items: [
        {
          text: 'Inicial',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Matematica',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Matematica ini',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: '5 años',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],

       singleSelect: false,

        selected: [],
        headers: [
          {
            text: 'Preguntas',
            align: 'left',
            sortable: false,
            value: 'name',
            class: 'warning'
          },
       //   { text: 'Seleccionadas', value: 'calories' },
         
          
        ],
        desserts: [
          {
            name: 'Descubre los cambios propios de su etapa de desarrollo y valora sus características personales y culturales.',
         //   calories: 159,
          },
          {
            name: 'Establece semejanzas y diferencias entre su propia cultura y la de sus compañeros.',
          //  calories: 305,
          },
          {
            name: 'Analiza las causas y consecuencias de sus emociones y utiliza estrategias pertinentes para regularlas.',
           // calories: 356,
          },
          {
            name: 'Asume una posición frente a un conflicto moral, tomando en cuenta principios éticos.',
          //  calories: 375,
          },
          {
            name: 'Manifiesta su deseo de ser una persona que no lastime a los otros.',
         //   calories: 392,
          },
            {
            name: 'Dialoga sobre la importancia del cuidado de sí mismo en relación a la salud sexual y reproductiva identificando situaciones que la ponen en riesgo.',
          //  calories: 305,
          },
         
     
        ],

       

        selected2: [],
        headers2: [
          {
            text: 'Desempeño Indicadores',
            align: 'left',
            sortable: false,
            value: 'name',
            class: 'info'
          },
       //   { text: 'Seleccionadas', value: 'calories' },
         
          
        ],
        desserts2: [
          {
            name: 'Frozen Yogurt',
         //   calories: 159,
          },
          {
            name: 'Cupcake',
          //  calories: 305,
          },
          {
            name: 'Gingerbread',
           // calories: 356,
          },
          {
            name: 'Jelly bean',
          //  calories: 375,
          },
          {
            name: 'Lollipop',
         //   calories: 392,
          },
            {
            name: 'Cupcake',
          //  calories: 305,
          },
          {
            name: 'Gingerbread',
           // calories: 356,
          },
          {
            name: 'Jelly bean',
          //  calories: 375,
          },
            {
            name: 'Cupcake',
          //  calories: 305,
          },
          {
            name: 'Gingerbread',
           // calories: 356,
          },
          {
            name: 'Jelly bean',
          //  calories: 375,
          },
        
     
        ],



        //
        

    };

  },
 
  mounted() {
     
    },

  methods: {

    },

  components: {

  }
}
</script>

<style scoped>
@font-face {
    font-family: "avenir black";
    src: url("../../public/fuentes/Avenir-Black.ttf");
    }

    @font-face {
    font-family: "avenir black oblique";
    src: url("../../public/fuentes/Avenir-BlackOblique.ttf");
    }

    .btn_block_style2{
        font-family: "avenir black";
        letter-spacing: 0.42px;
        font-size: 14px;
        background-color: #0277bd !important;
    }

    .btn_block_style2:hover {
        font-family: "avenir black oblique";
        /* background-color: #002f6c !important; */
        background-color: #ffbc00 !important;
        color: #000;
    }

</style>